import TtamSelectionBlocksBlock from './block/index.vue';
export default {
  TtamSelectionBlocksBlock,
};
